<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"/>
    </template>

    <v-card>
      <v-card-title
        class="title grey lighten-4"
        primary-title
      >
        Mover Processamento
      </v-card-title>
      <v-card-text class="px-0">
        <v-list
          rounded
        >
          <v-list-item-group
            v-model="selectedIdProject"
            color="info"
          >
            <v-list-item
              :value="null"
              :input-value="selectedIdProject === null || selectedIdProject === undefined || !(selectedIdProject instanceof Number)"
            >
              <v-list-item-icon>
                <v-icon>mdi-cancel</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Nenhum
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="project in _projectList"
              :key="project['id_project']"
              :value="project['id_project']"
              :input-value="selectedIdProject === project['id_project']"
            >
              <v-list-item-icon>
                <v-icon>mdi-folder</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                {{project["nm_project"]}}
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn
          color="accent"
          text
          @click="active = false"
        >
          Fechar
        </v-btn>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="onMoveProcessingClick"
          :loading="isMoving"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapGetters} from "vuex"
  import {GET_PROJECT_LIST} from "../../store/modules/project"
  import {MOVE_PROCESSING} from "../../store/modules/processing"

  export default {
    name: "ProcessingMoveDialog",
    props: {
      processing: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      active: false,
      selectedIdProject: null,
      isMoving: false,
    }),
    methods: {
      onMoveProcessingClick() {
        this.isMoving = true
        this._moveProcessing({
            idProcessing: this.processing["id_processing"],
            cdProject: (this.selectedIdProject === 0) ? null : this.selectedIdProject
          })
          .finally(() => {
            this.isMoving = false
          })
      },
      ...mapActions({
        _moveProcessing: MOVE_PROCESSING,
      }),
    },
    computed: {
      ...mapGetters({
        _projectList: GET_PROJECT_LIST,
      }),
    },
    watch: {
      active(newValue) {
        if (newValue) this.selectedIdProject = this.processing["cd_project"]
      },
    },
  }
</script>

<style scoped>

</style>
